import { t, tString } from './translate';
/**
 * Display the schema name row.
 * It includes the property name, type, required and deprecated status.
 */
export function OpenAPISchemaName(props) {
    var schema = props.schema, type = props.type, propertyName = props.propertyName, required = props.required, context = props.context;
    var additionalItems = schema && getAdditionalItems(schema, context);
    return (<span className="openapi-schema-name">
            {propertyName ? (<span data-deprecated={schema === null || schema === void 0 ? void 0 : schema.deprecated} className="openapi-schema-propertyname">
                    {propertyName}
                </span>) : null}
            <span>
                {type ? <span className="openapi-schema-type">{type}</span> : null}
                {additionalItems ? (<span className="openapi-schema-type">{additionalItems}</span>) : null}
            </span>
            {(schema === null || schema === void 0 ? void 0 : schema.readOnly) ? (<span className="openapi-schema-readonly">
                    {t(context.translation, 'read_only')}
                </span>) : null}
            {(schema === null || schema === void 0 ? void 0 : schema.writeOnly) ? (<span className="openapi-schema-writeonly">
                    {t(context.translation, 'write_only')}
                </span>) : null}
            {required ? (<span className="openapi-schema-required">
                    {t(context.translation, 'required')}
                </span>) : (<span className="openapi-schema-optional">
                    {t(context.translation, 'optional')}
                </span>)}
            {(schema === null || schema === void 0 ? void 0 : schema.deprecated) ? (<span className="openapi-deprecated">{t(context.translation, 'deprecated')}</span>) : null}
        </span>);
}
function getAdditionalItems(schema, context) {
    var additionalItems = '';
    if (schema.minimum || schema.minLength || schema.minItems) {
        additionalItems += " \u00B7 ".concat(tString(context.translation, 'min').toLowerCase(), ": ").concat(schema.minimum || schema.minLength || schema.minItems);
    }
    if (schema.maximum || schema.maxLength || schema.maxItems) {
        additionalItems += " \u00B7 ".concat(tString(context.translation, 'max').toLowerCase(), ": ").concat(schema.maximum || schema.maxLength || schema.maxItems);
    }
    if (schema.nullable) {
        additionalItems = " | ".concat(tString(context.translation, 'nullable').toLowerCase());
    }
    return additionalItems;
}
